var pageHttp={
  recordPage(obj,projectPkId,estateId,estateName,phone){//记录访问界面
    var pageData ={};
    var channel = null;
    
    if(obj.$route.query.channel!=null){
      channel  = obj.$route.query.channel;
    }

    if(channel==null && sessionStorage.getItem('channel')!=null){
      channel  = sessionStorage.getItem('channel');
    }
    
    pageData.channel = channel;
    
    if(channel!=null && channel!="" && channel.indexOf('@')!=-1){
      var str = channel.split('@');
      pageData.channel = str[0];
      pageData.keyword = str[1];
    }
    
    //获取当前页面地址
    pageData.url = decodeURIComponent(window.location.href);
    pageData.lastUrl = document.referrer;
    
    if(pageData.url.indexOf("?")==-1 && pageData.lastUrl.indexOf("?")!=-1) {
      pageData.url = pageData.url+"?"+pageData.lastUrl.split("?")[1]
    }
    
    
    pageData.subjectId = projectPkId;
    pageData.estateId = estateId;
    pageData.estateName = estateName;
    pageData.phone = phone;
    
    if(pageData.estateId==null || pageData.estateId==""){
      return false;
    }

    obj.$http.post("/api/sendSms/recordPage",pageData).then((response)=>{
    }).catch((response)=>{
       //console.info('response',response);
    })
  }
}
export default pageHttp;


// WEBPACK FOOTER //
// ./src/store/recordPage.js